import React, {useState} from 'react';
import {Field, formValueSelector, change} from 'redux-form'
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {
    FORM_CHECKBOX_BVM_CONNECTION,
    FORM_FIELD_AVAILABILITY_DATE,
    FORM_FIELD_CLIENT_TYPE,
    FORM_FIELD_ENGINE_SERIAL_NUMBER,
    FORM_FIELD_ENGINE_TYPE,
    FORM_FIELD_GEARBOX_SERIAL_NUMBER,
    FORM_FIELD_GEARBOX_TYPE,
    FORM_FIELD_MORE_DETAILS,
    FORM_FIELD_SRC_CLAIM_N,
    FORM_FIELD_SRC_REQUEST,
    FORM_FIELD_STEERING_WHEEL,
    FORM_LABEL_AVAILABILITY_DATE,
    FORM_LABEL_CLIENT_TYPE,
    FORM_LABEL_ENGINE_SERIAL_NUMBER,
    FORM_LABEL_ENGINE_TYPE,
    FORM_LABEL_GEARBOX_SERIAL_NUMBER,
    FORM_LABEL_GEARBOX_TYPE,
    FORM_LABEL_MORE_DETAILS,
    FORM_LABEL_SRC_CLAIM_N,
    FORM_LABEL_SRC_REQUEST,
    FORM_LABEL_STEERING_WHEEL,
    FORM_SUPPLEMENTARY_INFORMATION_SECTION,
    FORM_VEHICLE_DETAIL_SECTION,
    FORM_LABEL_MILEAGE,
    FORM_FIELD_MILEAGE,
} from '../../../../../../constants/formConstants';
import {InputFieldWithValidation} from '../../../../../common/InputFieldWithValidation';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import InputSelectFieldWithValidation from '../../../../../common/InputSelectFieldWithValidation';
import formMessages from '../../../../../../intl/sparePartsOrders/formMessages';
import clientTypeMessages from '../../../../../../intl/technicalDocumentations/clientTypeMessages';
import * as formConstants from '../../../../../../constants/formConstants';
import commonMessages from '../../../../../../intl/common/commonMessages';
import BorderRadius from '../../../../../common/styled/BorderRadius';
import Div from '../../../../../common/styled/HideAbleDiv';
import {srcRequestType} from '../../../../../../constants/Utils';
import steeringWheelMessages from '../../../../../../intl/sparePartsOrders/steeringWheelMessages';
import DatePickerComponent from '../../../../../common/datePicker/DatePickerComponent';
import {required} from '../../../../../common/validationCommons';
import * as moment from 'moment';

const SupplementaryInformationSection = (props) => {
    const { bvmConnection, readOnly, userRights, reqFields, change, srcRequest, userGroup } = props;
    const [srcNumberDisabled, setSrcNumberDisabled] = useState(!srcRequest || srcRequest === 'NO');

    const section = formConstants.FORM_SUPPLEMENTARY_INFORMATION_SECTION;

    // Benelux countries (BE, NL, LU) and Morocco (MA)
    const mileageRequiredCountries = ['BE', 'NL', 'LU', 'MA'];
    const isMileageRequired = mileageRequiredCountries.includes(userGroup) && reqFields.includes(FORM_FIELD_MILEAGE);

    const handleSrcRequestChecker = (event, value) => {
        if (value && (value === 'YES' || value === 'PRESIDENT')) {
            setSrcNumberDisabled(false);
        } else {
            change(`${section}.${formConstants.FORM_FIELD_SRC_CLAIM_N}`, '');
            setSrcNumberDisabled(true);
        }
    };

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...formMessages.SUPPLEMENTARY_INFORMATION_SECTION}/>
            </h3>
            <BorderRadius size={5} className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row">
                    <Div className="col-xl-3 col-md-6 pb-1">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_ENGINE_TYPE]}
                                                  field={FORM_FIELD_ENGINE_TYPE}
                                                  maxLength={6}
                                                  isDisabled={!userRights.canEditSuppInformations || readOnly || bvmConnection}
                                                  isRequired={reqFields.includes(FORM_FIELD_ENGINE_TYPE)}
                                                  isSmall/>
                    </Div>
                    <Div className="col-xl-3 col-md-6 pb-1">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_ENGINE_SERIAL_NUMBER]}
                                                  field={FORM_FIELD_ENGINE_SERIAL_NUMBER}
                                                  maxLength={7}
                                                  isDisabled={!userRights.canEditSuppInformations || readOnly || bvmConnection}
                                                  isRequired={reqFields.includes(FORM_FIELD_ENGINE_SERIAL_NUMBER)}
                                                  isSmall/>
                    </Div>
                    <Div className="col-xl-3 col-md-6 pb-1">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_GEARBOX_TYPE]}
                                                  field={FORM_FIELD_GEARBOX_TYPE}
                                                  maxLength={6}
                                                  isDisabled={!userRights.canEditSuppInformations || readOnly || bvmConnection}
                                                  isRequired={reqFields.includes(FORM_FIELD_GEARBOX_TYPE)}
                                                  isSmall/>
                    </Div>
                    <Div className="col-xl-3 col-md-6 pb-1">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_GEARBOX_SERIAL_NUMBER]}
                                                  field={FORM_FIELD_GEARBOX_SERIAL_NUMBER}
                                                  maxLength={7}
                                                  isDisabled={!userRights.canEditSuppInformations || readOnly || bvmConnection}
                                                  isRequired={reqFields.includes(FORM_FIELD_GEARBOX_SERIAL_NUMBER)}
                                                  isSmall/>
                    </Div>
                </div>
                <div className="form-row">
                    <Div className="col-xl-3 col-lg-4 col-md-6">
                        <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_STEERING_WHEEL]}
                                                        field={FORM_FIELD_STEERING_WHEEL}
                                                        options={['LEFT', 'RIGHT', 'OTHER']}
                                                        intlMessages={steeringWheelMessages}
                                                        isDisabled={!userRights.canEditSuppInformations || readOnly}
                                                        isRequired={reqFields.includes(FORM_FIELD_STEERING_WHEEL)}
                        />
                    </Div>
                    <Div className="col-xl-3 col-lg-4 col-md-6">
                        <Field name={FORM_FIELD_AVAILABILITY_DATE} component={DatePickerComponent}
                               label={formMessages[FORM_LABEL_AVAILABILITY_DATE]}
                               validate={reqFields.includes(FORM_FIELD_AVAILABILITY_DATE) ? required : undefined}
                               isRequired={reqFields.includes(FORM_FIELD_AVAILABILITY_DATE) && !readOnly}
                               isClearable
                               isDisabled={!userRights.canEditSuppInformations || readOnly || bvmConnection}
                               parse={(e) => e ? moment(e).format('YYYY-MM-DD') : ""}
                        />
                    </Div>
                    <Div className="col-xl-2 col-lg-4 col-md-6">
                        <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_CLIENT_TYPE]}
                                                        field={FORM_FIELD_CLIENT_TYPE}
                                                        options={Object.keys(clientTypeMessages)}
                                                        intlMessages={clientTypeMessages}
                                                        isDisabled={!userRights.canEditSuppInformations || readOnly}
                        />
                    </Div>
                    <Div className="col-xl-2 col-lg-4 col-md-6">
                        <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_SRC_REQUEST]}
                                                        field={FORM_FIELD_SRC_REQUEST}
                                                        options={srcRequestType}
                                                        sort={false}
                                                        intlMessages={commonMessages}
                                                        isRequired={reqFields.includes(FORM_FIELD_SRC_REQUEST)}
                                                        isDisabled={!userRights.canEditSuppInformations || readOnly || readOnly}
                                                        noEmpty
                                                        handleChange={handleSrcRequestChecker}
                        />
                    </Div>
                    <Div className="col-xl-3 col-lg-4 col-md-6">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_SRC_CLAIM_N]}
                                                  field={FORM_FIELD_SRC_CLAIM_N}
                                                  maxLength={256}
                                                  isDisabled={!userRights.canEditSuppInformations || readOnly || srcNumberDisabled}
                                                  isRequired={reqFields.includes(FORM_FIELD_SRC_CLAIM_N)}
                                                  isSmall
                        />
                    </Div>
                    <Div className="col-xl-3 col-lg-4 col-md-6">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_MILEAGE]}
                                                  field={FORM_FIELD_MILEAGE}
                                                  maxLength={256}
                                                  isDisabled={!userRights.canEditMileage || readOnly}
                                                  isRequired={isMileageRequired}
                                                  isSmall
                        />
                    </Div>
                </div>
                <div className="form-row">
                    <Div className="col-sm-12 pr-0">
                        <TextareaFieldWithValidation label={formMessages[FORM_LABEL_MORE_DETAILS]}
                                                     field={FORM_FIELD_MORE_DETAILS}
                                                     isDisabled={!userRights.canEditSuppInformationsText || readOnly}
                                                     isRequired={reqFields.includes(FORM_FIELD_MORE_DETAILS)}
                                                     rows={6}
                        />
                    </Div>
                </div>
            </BorderRadius>
        </>
    )

}

const selector = (form, ...other) => (formValueSelector(form))(...other);
const mapStateToProps = (state, initialProps) => ({
    srcRequest: selector(initialProps.form, state, `${FORM_SUPPLEMENTARY_INFORMATION_SECTION}.${FORM_FIELD_SRC_REQUEST}`),
    bvmConnection: selector(initialProps.form, state, `${FORM_VEHICLE_DETAIL_SECTION}.${FORM_CHECKBOX_BVM_CONNECTION}`),
    userGroup: state.profile.userDetail.group,
});

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, name, value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(SupplementaryInformationSection);
